import React from 'react';
import { Box, Icon, Text } from '@chakra-ui/react';
import { QuestionOutlineIcon } from '@chakra-ui/icons';
import { ff } from '../theme';

export function openCrispChat(): void {
  if (window.$crisp) {
    window.$crisp.push(['do', 'chat:show']);
    window.$crisp.push(['do', 'chat:open']);
  }
}

export interface FrostedSupportButtonProps {
  onClick?: () => void;
}

/** Support control — icon + label in a simple bordered pill. */
const FrostedSupportButton: React.FC<FrostedSupportButtonProps> = ({
  onClick = openCrispChat,
}) => (
  <Box
    as="button"
    type="button"
    aria-label="Support"
    h="44px"
    bg="white"
    border="1px solid"
    borderColor={ff.line}
    borderRadius="full"
    display="flex"
    alignItems="center"
    justifyContent="center"
    cursor="pointer"
    onClick={onClick}
    px={4}
    gap={2}
    flexShrink={0}
    _hover={{ bg: ff.grey }}
    _active={{ bg: ff.line }}
  >
    <Icon as={QuestionOutlineIcon} color={ff.ink} boxSize="14px" />
    <Text fontSize="13px" fontWeight={600} color={ff.ink}>
      Support
    </Text>
  </Box>
);

export default FrostedSupportButton;
